<div>
  <app-empty-data-message
    *ngIf="(!loading && !dataTable) || dataTable.length === 0"
  ></app-empty-data-message>
  <app-table
    *ngIf="dataTable && dataTable.length > 0"
    [displayedColumns]="displayedColumns"
    [datasource]="dataTable"
  >
  </app-table>
</div>
